export enum Permissions {
    // Dashboard
    DASHBOARD = 'DASHBOARD',

    // Sales Transaction
    SALES_TRANSACTION_CREATE = 'SALES_TRANSACTION_CREATE',
    SALES_TRANSACTION_UPDATE = 'SALES_TRANSACTION_UPDATE',
    SALES_TRANSACTION_VIEW_DETAIL = 'SALES_TRANSACTION_VIEW_DETAIL',
    SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS = 'SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS',
    SALES_TRANSACTION_VIEW_MY_TRANSACTIONS = 'SALES_TRANSACTION_VIEW_MY_TRANSACTIONS',
    SALES_TRANSACTION_VIEW_MY_OFFERS = 'SALES_TRANSACTION_VIEW_MY_OFFERS',
    SALES_TRANSACTION_VIEW_CURRENT_TRANSACTIONS = 'SALES_TRANSACTION_VIEW_CURRENT_TRANSACTIONS',
    SALES_TRANSACTION_CANCEL = 'SALES_TRANSACTION_CANCEL',
    SALES_TRANSACTION_EXPORT = 'SALES_TRANSACTION_EXPORT',
    SALES_TRANSACTION_UPDATE_TARGET_HANDOVER_DATE = 'SALES_TRANSACTION_UPDATE_TARGET_HANDOVER_DATE',
    SALES_TRANSACTION_FILTER_TARGET_HANDOVER_DATE = 'SALES_TRANSACTION_FILTER_TARGET_HANDOVER_DATE',

    // Vehicle
    VEHICLE_UPDATE_INFO = 'VEHICLE_UPDATE_INFO',
    VEHICLE_ADD_DIAGRAM_COMMENT = 'VEHICLE_ADD_DIAGRAM_COMMENT',

    // Offer
    OFFER_CREATE_OFFER_SESSION = 'OFFER_CREATE_OFFER_SESSION',
    OFFER_UPDATE_OFFER_SESSION = 'OFFER_UPDATE_OFFER_SESSION',
    OFFER_UPDATE_OFFER_PERIOD = 'OFFER_UPDATE_OFFER_PERIOD',
    OFFER_END_OFFER_SESSION = 'OFFER_END_OFFER_SESSION',
    OFFER_VIEW_TOP_BIDS = 'OFFER_VIEW_TOP_BIDS',
    OFFER_VIEW_PAST_BIDS = 'OFFER_VIEW_PAST_BIDS',
    OFFER_VIEW_TOP_OFFER_AMOUNTS = 'OFFER_VIEW_TOP_OFFER_AMOUNTS',
    OFFER_UPDATE_HANDLING_CHARGES_AND_MARGIN = 'OFFER_UPDATE_HANDLING_CHARGES_AND_MARGIN',
    OFFER_UPDATE_AWARDED_OFFER = 'OFFER_UPDATE_AWARDED_OFFER',
    OFFER_SUBMIT_BID = 'OFFER_SUBMIT_BID',
    OFFER_BIDDING_LIVE_DURATION = 'OFFER_BIDDING_LIVE_DURATION',

    // User Management
    USER_ACCOUNT_APPROVAL = 'USER_ACCOUNT_APPROVAL',
    USER_ACCOUNT_UPDATE = 'USER_ACCOUNT_UPDATE',
    USER_ACCOUNT_GET_DETAIL = 'USER_ACCOUNT_GET_DETAIL',
    USER_ACCOUNT_LIST = 'USER_ACCOUNT_LIST',
    USER_ACCOUNT_UPDATE_STATUS = 'USER_ACCOUNT_UPDATE_STATUS',

    // User Profile
    USER_PROFILE_UPDATE_INFO = 'USER_PROFILE_UPDATE_INFO',
    USER_PROFILE_VIEW_DATABASE_ID = 'USER_PROFILE_VIEW_DATABASE_ID',

    // Notification & Activities Log
    NOTIFICATION_LOG_LIST = 'NOTIFICATION_LOG_LIST',
    ACTIVITIES_LOG_EXPORT = 'ACTIVITIES_LOG_EXPORT',

    // Settings
    SETTINGS_UPDATE_TEMPLATE_USE_CASES = 'SETTINGS_UPDATE_TEMPLATE_USE_CASES',
    SETTINGS_UPDATE_COMPANY_SETTINGS = 'SETTINGS_UPDATE_COMPANY_SETTINGS',
}

export default Permissions;
